import { CommissionTier } from 'src/app/recruiting/locums-margin-calculator/models/commission-tier.model';
import { MalpracticeInsuranceRate } from 'src/app/recruiting/locums-margin-calculator/models/malpractice-insurance-rate.model';

import { TargetMargin } from '../../models/target-margin.model';

export interface MarginCalculationsSlice {
    // profit
    grossProfit: number;
    grossProfitMargin: number;

    // commission
    commissionTiers: CommissionTier[];
    commissionTier: number;
    estimatedCommissionPerHour: number;
    estimatedCommissionPerShift: number;
    totalCommission: number;

    // revenue
    targetMargins: TargetMargin[];
    targetMargin: number;
    shiftRevenue: number;
    billableExpenses: number;
    contractFee: number;
    totalRevenue: number;

    // cost
    shiftCost: number;
    malpracticeInsuranceRates: MalpracticeInsuranceRate[];
    malpracticeInsuranceRate: number;
    malpracticeInsurance: number;
    accommodations: number;
    otherExpenses: number;
    totalCost: number;
}

export const initialMarginCalculationsSlice: MarginCalculationsSlice = {
    //temporary values for initial state
    grossProfit: 0,
    grossProfitMargin: 0,

    commissionTiers: [],
    commissionTier: 0,
    estimatedCommissionPerHour: 0,
    estimatedCommissionPerShift: 0,
    totalCommission: 0,

    targetMargins: [],
    targetMargin: 0,
    shiftRevenue: 0,
    billableExpenses: 0,
    contractFee: 0,
    totalRevenue: 0,

    shiftCost: 0,
    malpracticeInsuranceRates: [],
    malpracticeInsuranceRate: 0,
    malpracticeInsurance: 0,
    accommodations: 0,
    otherExpenses: 0,
    totalCost: 0
};
